import apiClient from "@/api/apiClient";
import {
  spawnCreateApiFunction,
  spawnCreateMultipleApiFunction,
  spawnDeleteApiFunction,
  spawnUpdateApiFunction,
  type ApiResourceConfig,
} from "@/utils/api";

const table = "maintenances_to_devices";
const query = `
                *,
                device:devices(
                  *,
                  device_tags(*),
                  connections_to_devices(*),
                  manufacturer:manufacturers(*),
                  model:device_models(*)
                ),
                checklist_template:checklist_templates(
                  *,
                  checklist_template_items(*)
                )
              `;

export const apiConfigMaintenancesToDevices: ApiResourceConfig<typeof table, typeof query> = {
  table,
  query,
  searchables: [],
  sortables: [],
};

export const createMaintenanceToDevice = spawnCreateApiFunction({ table, query });
export const createMultipleMaintenanceToDevices = spawnCreateMultipleApiFunction({ table, query });
export const updateMaintenanceToDevice = spawnUpdateApiFunction({ table, query });
export const deleteMaintenanceToDevice = spawnDeleteApiFunction({ table });

export const getMaintenancesToDevices = async (maintenance_id: string) => {
  const { data, error } = await apiClient.from(table).select(query).eq("maintenance_id", maintenance_id);
  if (error) throw error;
  return data;
};
